import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"

export const getMaxAvailableContentDurationInvoke: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getMaxAvailableContentDuration",
    src: "getMaxAvailableContentDuration",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        const maxDurationValue = evt.data || 30 * 3600

        return {
          maxAvailableContentDuration: maxDurationValue,
          seconds:
            !ctx.seconds || ctx.seconds > maxDurationValue
              ? maxDurationValue
              : ctx.seconds
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getMaxAvailableContentDuration", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
